import _ from 'lodash'

class ShortcutProvider {
  constructor() {
    this._collection = {
      'new': { keyCode: 78, altKey: true }, // 78:n
      'add': { keyCode: 45, ctrlKey: true }, // 45:insert
      'edit': { keyCode: 32, ctrlKey: true }, // 32:space
      'delete': { keyCode: 46, shiftKey: true }, // 46:delete
      'help': { keyCode: 112 }, // 112:F1
      'favorite-tabs': { keyCode: 113 }, // 113:F2
      'search': { keyCode: 114 }, // 114:F3
      'save': { keyCode: 83, ctrlKey: true }, // 83:s
      'save-new': { keyCode: 83, shiftKey: true, ctrlKey: true }, // 83:s
      'temp-save': { keyCode: 83, shiftKey: true }, // 83:s
      'save-print': { keyCode: 80, shiftKey: true }, // 80:p
      'print': { keyCode: 80, ctrlKey: true }, // 80:p
      'excel': { keyCode: 88, altKey: true }, // 88:x
      'insert': { keyCode: 45, ctrlKey: true }, // 45:insert
      'enter-only': { keyCode: 13 }, // 13:enter
      'select': { keyCode: 83, shiftKey: true }, // 13:enter
      'enter': { keyCode: 13, ctrlKey: true }, // 13:enter
      'exit': { keyCode: 27 }, // 27:Esc
      'view-document': { keyCode: 114 }, // 114:F3
      'close-tab': { keyCode: 192, ctrlKey: true }, // 192:`
      'settings': { keyCode: 123, ctrlKey: true }, // 123:F12
      'copy': { keyCode: 67, ctrlKey: true, altKey: false, shiftKey: false }, // 67:C
      'duplicate': { keyCode: 68, ctrlKey: true, altKey: false, shiftKey: false }, // 100:d
      'change-log': { keyCode: 76, ctrlKey: true, altKey: false, shiftKey: false }, // 76:L
      'attachment': { keyCode: 84, altKey: true },// 84:T
      'ctrl-insert': { keyCode: 45, ctrlKey: true }, // 45:insert
      'ctrl-arrow-right': { keyCode: 39, ctrlKey: true }, // 45:insert
      'ctrl-arrow-left': { keyCode: 37, ctrlKey: true }, // 45:insert
      'snapshot': { keyCode: 81, ctrlKey: true, altKey: true, }, // 81:D

      'install': {
        'done': { keyCode: 83, ctrlKey: true, shiftKey: true }, // 83:s
        'next': { keyCode: 33 }, // 33: page up
        'prev': { keyCode: 34 } // 34: page down
      },

      'dialog': {
        'ok': { keyCode: [13, 32] }, // 13:enter & 32:space
        'cancel': { keyCode: 27 }, // 27:escape
        'yes': { keyCode: 13 }, // 13:enter
        'yesAs': { keyCode: 13, ctrlKey: true }, // 13:enter
        'no': { keyCode: 27 }, // 27:escape
        'return': { keyCode: 27 } // 27:escape
      },

      'fiscal': {
        'grid-enter': { keyCode: [37, 13] }, // 37:left arrow //13:enter
        'grid-up': { keyCode: 38 }, // 38:up arrow
        'grid-down': { keyCode: 40 }, // 40:down arrow
        'exit-grid': { keyCode: [39, 27] }, // 39:right arrow //27:Esc
        'access-manager': { keyCode: [113], ctrlKey: true } // 113:F2
      },

      'account': {
        'account-ltc': { keyCode: 114 }, // 114:F3
        'account-information': { keyCode: 113, ctrlKey: true }, // 113:F2
        'ignore-changes': { keyCode: 112 }, // 112:F1
        'delete': { keyCode: 46, shiftKey: false, ctrlKey: true, } // 46:delete
      },

      'center': {
        'center-information': { keyCode: 113, ctrlKey: true }, // 113:F2
        'ignore-changes': { keyCode: 112 } // 112:F1
      },

      'document': {
        'save-memo': { keyCode: 83, ctrlKey: true, shiftKey: true }, // 83:s
        'ignore-changes': { keyCode: 112 }, // 112:F1
        'copy-value': { keyCode: 68, ctrlKey: true, altKey: false, shiftKey: true }, // 68:D
        'balance-table': { keyCode: 13, ctrlKey: true, altKey: true, shiftKey: false }, // 13:enter
        'delete': { keyCode: 46, ctrlKey: false, altKey: false, shiftKey: true }, // 46:delete
      },
      'factor': {
        'balance-operation': { keyCode: 13, ctrlKey: true, altKey: false, shiftKey: false }, // 13:enter
        'fetch-suggestion-price': { keyCode: 69, ctrlKey: true, altKey: false, shiftKey: false } // 69:E
      },

      'table': {
        'insert-new-row': { keyCode: 45, ctrlKey: true }, // 45:insert
        'full-screen': { keyCode: 70, altKey: true }, // 70:f
        'insert-new-row-at-end': { keyCode: 45, ctrlKey: true, shiftKey: true }, // 45:insert
        'delete-row': { keyCode: 46, ctrlKey: true }, // 46:delete
        'copy': { keyCode: 67, altKey: true }, // 67:C
        'templates-save-new': { keyCode: 83, ctrlKey: true, shiftKey: true }, // 83:S
        'templates-select': { keyCode: 13, ctrlKey: true }, // 13:enter
        'new-row': { keyCode: 40 },// 40:arrow-down
        'move-up': { keyCode: 38, altKey: true },// 38:arrow-up
        'move-down': { keyCode: 40, altKey: true },// 40:arrow-down
        'ctrl-move-up': { keyCode: 38, ctrlKey: true },// 38:arrow-up
        'ctrl-move-down': { keyCode: 40, ctrlKey: true },// 40:arrow-down
        'sum-till-current-row': { keyCode: 83, altKey: true },// 83:C
      },

      'ag-grid': {
        'copy-to-all-rows': { keyCode: 68, ctrlKey: true, shiftKey: true, altKey: false },// D:68
        'copy-to-empty-rows': { keyCode: 68, ctrlKey: true, altKey: true, shiftKey: false },// D:68
        'copy-to-next-row': { keyCode: 68, ctrlKey: true, altKey: false, shiftKey: false },// D:68
        'clear-current-row': { keyCode: 69, ctrlKey: true, altKey: false, shiftKey: false },// E:69
        'clear-current-column': { keyCode: 69, ctrlKey: true, altKey: true, shiftKey: false },// E:69
        'copy-to-current-row-cells': { keyCode: 71, ctrlKey: true, altKey: false, shiftKey: false },// G:71
        'copy-to-empty-current-row-cells': { keyCode: 71, ctrlKey: true, altKey: true, shiftKey: false }// G:71
      },

      'treasury': {
        'create-cheque': { keyCode: 112 }, // 112:F1
        'create-items': { keyCode: 113, ctrlKey: true }, // 113:F2
        'item-trace': { keyCode: 114 }, // 114:F3
        'change-state': { keyCode: 115 }, // 115:F4
        'delete-cheque': { keyCode: 46, ctrlKey: false, shiftKey: true }, // 46:delete
        'delete-last-trace': { keyCode: 46, ctrlKey: false, shiftKey: true }, // 46:delete
        'cheque-modify': { keyCode: 113, ctrlKey: true }, // 113:F2
        'ignore-changes': { keyCode: 112 }, // 112:F1
        'attachments': { keyCode: 115 }, // 115:F4
        'state-1': { keyCode: 49, ctrlKey: true }, // 49:1
        'state-2': { keyCode: 50, ctrlKey: true }, // 50:2
        'state-3': { keyCode: 51, ctrlKey: true }, // 51:3
        'state-4': { keyCode: 52, ctrlKey: true }, // 52:4
        'state-5': { keyCode: 53, ctrlKey: true }, // 53:5
        'state-6': { keyCode: 54, ctrlKey: true }, // 54:6
        'state-7': { keyCode: 55, ctrlKey: true }, // 55:7
        'state-8': { keyCode: 56, ctrlKey: true }, // 55:8
        'state-9': { keyCode: 57, ctrlKey: true }, // 55:9
        'create-cheque-items': { keyCode: 32, ctrlKey: true }, // 32:SPACE
      },

      'sale': {
        'attachments-transaction': { keyCode: 112, ctrlKey: true }, // 112:F1
        'attachments-factor': { keyCode: 113, ctrlKey: true }, // 113:F2
        'attachments': { keyCode: 113, ctrlKey: true }, // 113:F2
        'fill-accepted': { keyCode: 13, ctrlKey: true, altKey: false, shiftKey: false }, // 13:enter
        'fill-accepted-all': { keyCode: 13, ctrlKey: true, altKey: true, shiftKey: false }, // 13:enter
        'add-from-pda': { keyCode: 115 }, // 115:F4,
        'show-related-hawala': { keyCode: 116 }, // 116:F5
        'show-related-receipt': { keyCode: 117 } // 116:F7
      },

      'input': {
        '3zero': { keyCode: 107 }, // 107:+
        '2zero': { keyCode: 109 }, // 109:-
        'selectAll': { keyCode: [97, 65, 222], ctrlKey: true }, // 97:a
        'copy': { keyCode: [99, 67, 224], ctrlKey: true }, // 99:c
        'paste': { keyCode: [118, 86], ctrlKey: true }, // 118:v
        'cut': { keyCode: 88, ctrlKey: true }, // 88:x
        'right': { keyCode: 39 }, // 37:right arrow
        'left': { keyCode: 37 }, // 37:left arrow
      },

      'textarea': {
        'left': { keyCode: 37 }, // 37:left arrow
        'up': { keyCode: 38 }, // 38:up arrow
        'down': { keyCode: 40 }, // 40:down arrow
        'selectAll': { keyCode: [97, 65, 222], ctrlKey: true }, // 97:a
        'nextTab': { keyCode: 13, shiftKey: true }, // 13:enter
        'cut': { keyCode: 88, ctrlKey: true }, // 88:x
      }
    }
  }

  find(key, group) {
    var scg = this._collection

    if (typeof group !== 'undefined') {
      scg = this._collection[group]
      if (typeof scg === 'undefined') {
        throw new Error(`shortcut group '${group}' not found`)
      }
    }

    var defaultSc = {
      ctrlKey: false,
      shiftKey: false,
      altKey: false
    }

    var sc = scg[key]
    if (typeof sc === 'undefined') {
      throw new Error(`shortcut ${key} not found in group '${group}'`)
    }

    sc = _.extend(defaultSc, sc)
    return sc
  }

  display(key, group) {
    const shortcut = this.find(key, group)

    var arr = []

    if (shortcut.keyCode > 0) {
      if (shortcut.ctrlKey === true) {
        arr.push('Ctrl')
      }
      if (shortcut.shiftKey === true) {
        arr.push('Shift')
      }
      if (shortcut.altKey === true) {
        arr.push('Alt')
      }

      var key = shortcut.keyCode
      var keyChar = String.fromKeyCode(key)
      keyChar = keyChar || ''

      arr.push(keyChar)
      return arr.join(' + ')
    } else {
      return ''
    }
  }
}

export default new ShortcutProvider()
